export default __webpack_public_path__ + "assets/images/g-blocks-icon1-162a4c41.svg";